import useStorageState from '../useStorageState';

function useSessionStorageState(key, defaultValue) {
  return useStorageState(function () {
    return sessionStorage;
  }, key, defaultValue);
}

export default useSessionStorageState;